import {sumBy, filter} from 'lodash';
const valueIfNull = 0;

export const colSumTotal = (dealers = [], salesList = []) => {
  return dealers.map((dealer, index) => {
    const dataFiltered = filter(salesList, {'customerId': dealer.value});
    return sumBy(dataFiltered, 'totalQty');
  });
};

export const rowQuantities = (vehicleId, salesList = [], dealerList = []) => {
  return dealerList.map((dealer) => {
    const dataFiltered = filter(salesList,
      {'customerId': dealer.value, 'vehicleModelId': vehicleId});
    return dataFiltered && dataFiltered[0] ? +dataFiltered[0].totalQty : valueIfNull;
  });
};


export const getTotal = (total = []) => {
  const arrLen = total.length;
  const sliceObjectives = arrLen - 2;
  const dealers = total.slice(0, sliceObjectives - 1);
  const objectives = total.slice(sliceObjectives, arrLen);
  const sumDealers = dealers.reduce((acc, val) => acc + val, 0);
  return [
    ...dealers,
    sumDealers,
    ...objectives,
  ];
};

